"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FormComponent = /*#__PURE__*/function () {
  function FormComponent() {
    var _this = this;

    _classCallCheck(this, FormComponent);

    this.init();
    this.initNetteFormValidation(); // AJAX FORM SENT

    $.nette.ext("genericFormAjax", {
      before: function before(jqXHR, settings) {
        if ("nette" in settings) {
          $(settings.nette.el).addClass("sending");
        }
      },
      complete: function complete(jqXHR, status, settings) {
        _this._fieldsVisible = false;

        if ("nette" in settings) {
          $(settings.nette.el).removeClass("sending");
        }
      }
    });
  }
  /**
   * Nette Form Validation
   */


  _createClass(FormComponent, [{
    key: "initNetteFormValidation",
    value: function initNetteFormValidation() {
      Nette.showFormErrors = function (form, errors) {
        var validationType = $(form).attr("data-validationtype"); // REMOVE ALL ERRORS FROM FORM

        $("label.error", form).removeClass("error");
        $(".error-text", form).remove();

        switch (validationType) {
          case "fields":
            errors.forEach(function (error) {
              var field = $(error.element, form);
              var label = field.parent("label");
              label.addClass("error"); // SET STYLE AS INVALID FIELD
              // ADD ERROR MESSAGE TO FIELD

              label.append("<span class='error-text'>" + error.message + "</span>");
            });
        }
      };
    }
  }, {
    key: "init",
    value: function init() {}
  }]);

  return FormComponent;
}();